import {
  useOidc,
  useOidcAccessToken,
  useOidcIdToken
} from '@axa-fr/react-oidc';
import URI from 'urijs';
import { LoadingScreen } from '../../containers/LoadingScreen/LoadingScreen';
import history from '../../history';
import React, { useEffect } from 'react';

export const OIDCMain = () => {
  const { login, isAuthenticated } = useOidc();
  const { accessToken } = useOidcAccessToken();
  const { idToken } = useOidcIdToken();

  useEffect(() => {
    if (!isAuthenticated) {
      const parsedSearch = URI.parseQuery(window.location.search);
      login('/safetysecure', { login_hint: parsedSearch.login_hint });
    } else {
      history.replace(
        `/with-gp2token?accessToken=${accessToken}&idToken=${idToken}`
      );
    }
  }, [isAuthenticated]);

  return (
    <LoadingScreen
      redirectOnAuth={{
        login,
        isAuthenticated,
        accessToken,
        idToken
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/containers/OIDC/OIDCMain.jsx